import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useBrandHead } from '../../hooks/useBrandHead';
import { Header } from './Header';
import { Footer } from './Footer';
import { CookieBanner } from './CookieBanner';
export function Layout() {
  useBrandHead();
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = window.setTimeout(() => {
        document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({
          block: 'start'
        });
      }, 60);
      return () => window.clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'Corventa Talent Search',
      description: 'Executive search and professional recruitment firm.',
      serviceType: ['Executive search', 'Board search', 'Permanent recruitment', 'Interim recruitment', 'Talent mapping']
    });
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-ivory" data-id="element-427" data-mp="3dbihxxwk8tca">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-md focus:bg-gold focus:px-4 focus:py-2 focus:text-midnight" data-id="element-428" data-mp="38cp2hzxpqs9h">
        Skip to content
      </a>
      <Header data-id="element-429" data-mp="4vyszb2x9x31" />
      <motion.main id="main" key={pathname} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex-1" data-id="element-430" data-mp="4tck984apbj8">
        <Outlet data-id="element-431" data-mp="2kmuq1jhb35pr" />
      </motion.main>
      <Footer data-id="element-432" data-mp="2knwdknfidkod" />
      <CookieBanner data-id="element-433" data-mp="2knmiilflwnbt" />
    </div>;
}